import React, { useState } from 'react';
import { InputText } from '../input';
import 'components/views/login.css';

const LoginForm = ({
    onSubmit,
    error = '',
    loading = false,
    title = 'Iniciar Sesión',
    submitLabel = 'Iniciar Sesión',
    showTitle = true,
    className = '',
    formClassName = ''
}) => {
    const [usuario, setUsuario] = useState('');
    const [password, setPassword] = useState('');

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit?.({ usuario, password });
    };

    return (
        <div className={`login-container ${className}`.trim()}>
            {showTitle && <h2>{title}</h2>}
            <form onSubmit={handleSubmit} className={`login-form ${formClassName}`.trim()}>
                <div className="form-group">
                    <label>Nombre de usuario:</label>
                    <InputText
                        value={usuario}
                        onChange={(e) => setUsuario(e.target.value)}
                        placeholder="Ingrese su nombre de usuario"
                        name="usuario"
                    />
                </div>
                <div className="form-group">
                    <label>Contraseña:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        placeholder="Ingrese su contraseña"
                        name="password"
                        style={{ letterSpacing: "0px", height: "43px" }}
                        className="form-control"
                    />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button type="submit" className="btn btn-primary" disabled={loading}>
                    {loading ? 'Iniciando sesión...' : submitLabel}
                </button>
            </form>
        </div>
    );
};

export default LoginForm;
